import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFilterX = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M0 1.2A1.2 1.2 0 0 1 1.2 0h19.2a1.2 1.2 0 0 1 1.2 1.2v2.606a3.6 3.6 0 0 1-1.055 2.546l-5.297 5.296a1.2 1.2 0 1 1-1.696-1.697l5.296-5.296a1.2 1.2 0 0 0 .352-.849V2.4H2.4v1.472a1.2 1.2 0 0 0 .312.807l5.376 5.914c.2.22.312.508.312.807v8.535l4.162-1.387a1.2 1.2 0 1 1 .76 2.276l-5.743 1.914A1.2 1.2 0 0 1 6 21.6v-9.736L.936 6.294A3.6 3.6 0 0 1 0 3.873V1.2Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M15.951 15.951a1.2 1.2 0 0 1 1.697 0l6 6a1.2 1.2 0 1 1-1.697 1.697l-6-6a1.2 1.2 0 0 1 0-1.697Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M23.648 15.951a1.2 1.2 0 0 1 0 1.697l-6 6a1.2 1.2 0 1 1-1.697-1.697l6-6a1.2 1.2 0 0 1 1.697 0Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFilterX);
export default ForwardRef;
